/**
 * @file 存放一些stacks链的方法
 */
import {
  AppConfig,
  UserSession,
  showConnect,
  openSignTransaction,
} from '@stacks/connect';
import { StacksMainnet } from '@stacks/network';

const appConfig = new AppConfig(['store_write', 'publish_data']);

export const userSession = new UserSession({ appConfig });

export const isUserSignedIn = userSession.isUserSignedIn();

/**
 * 授权
 */
export const stxAuthenticate = (
  address: string
): Promise<{ success: boolean }> => {
  return new Promise((resolve) => {
    const isLogin = userSession.isUserSignedIn();
    if (
      isLogin &&
      address === userSession.loadUserData().profile.stxAddress.mainnet
    ) {
      resolve({
        success: true,
      });
      return;
    }

    // 由于stacks会缓存地址，如果地址不同需要调用私有方法退出登陆
    if (
      isLogin &&
      address !== userSession.loadUserData().profile.stxAddress.mainnet
    ) {
      userSession.signUserOut();
    }

    showConnect(
      {
        appDetails: {
          name: 'Stacks React Starter',
          icon: 'https://assets-global.website-files.com/618b0aafa4afde9048fe3926/6544a813b50e8e551ba7617a_stx.png',
        },
        redirectTo: '/',
        onFinish: () => {
          resolve({
            success: true,
          });
        },
        onCancel: () => {
          resolve({
            success: false,
          });
        },
        userSession,
      },
      window?.bybitWallet?.stacks
    );
  });
};

/**
 * 签名
 */
export const stxSignTrancaction = (
  data: any
): Promise<{ success: boolean; hash: string }> => {
  return new Promise((resolve) => {
    openSignTransaction(
      {
        network: new StacksMainnet(),
        txHex: data,
        onCancel: () => {
          resolve({
            success: false,
            hash: '',
          });
        },
        onFinish: ({ stacksTransaction }) => {
          resolve({
            success: true,
            hash: stacksTransaction.txid(),
          });
        },
      },
      window?.bybitWallet?.stacks
    );
  });
};
